export default __webpack_public_path__ + "static/media/access-twofactor.e24f3f10.jpg";